import React, { useRef } from 'react';
import { DoctoralPlanData } from '../types';
import { Card, DocRow, Hero, Kpis } from './dp120Parts';

interface DoctoralPlanViewProps {
  data: DoctoralPlanData | null;
  onNavigate: (viewId: string) => void;
  onUploadIup?: (file: File) => void;
}

const STRUCTURE: [string, string, string][] = [
  ['01', 'Учебные дисциплины', 'overview'],
  ['02', 'Тема и диссертационная работа', 'topic'],
  ['03', 'НИРД 1–6', 'nird'],
  ['04', 'Публикационный план', 'publications'],
  ['05', 'Педагогическая практика', 'practices'],
  ['06', 'Исследовательская практика', 'practices'],
  ['07', 'Научная стажировка', 'internship'],
  ['08', 'Этапы подготовки к защите', 'defense'],
];

export const DoctoralPlanView: React.FC<DoctoralPlanViewProps> = ({ data, onNavigate, onUploadIup }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  return (
    <>
      <Hero
        kicker="INDIVIDUAL PLAN"
        title="Индивидуальный план докторанта"
        text="Отдельный основной документ на весь период обучения: структура плана, версия Word, подписи и утверждённый файл."
        color="#f1b93f"
        actions={
          <>
            <button type="button" className="dp120-btn gold" onClick={() => onNavigate('documents')}>
              Открыть образец
            </button>
            <button type="button" className="dp120-btn mint" onClick={() => inputRef.current?.click()}>
              Загрузить план
            </button>
            <input
              ref={inputRef}
              className="dp120-hidden-file"
              type="file"
              onChange={(e) => {
                const file = e.target.files?.[0];
                if (file && onUploadIup) onUploadIup(file);
              }}
            />
          </>
        }
      />
      <Kpis
        items={[
          ['Word', data?.word_status || 'Ожидает', 'Рабочая версия'],
          ['Версия', data?.version_label || 'v1', 'История изменений сохраняется'],
          ['Подписи', data?.signatures_status || 'Ожидают', 'Фактические подписи / согласования'],
          ['Связь с НИРД', String(data?.nird_links_count ?? 6), 'Каждый семестр связан с планом'],
        ]}
      />
      <div className="dp120-grid">
        <Card title="Основной файл ИУП" sub="Хранится отдельно от приказов по теме.">
          <DocRow
            title="Индивидуальный план"
            file={data?.file_name}
            onPick={onUploadIup}
          />
        </Card>
        <Card title="Структура индивидуального плана" sub="Связано с рабочими разделами кабинета.">
          <div className="dp120-list">
            {STRUCTURE.map(([num, title, route]) => (
              <button
                key={title}
                type="button"
                className="dp120-row"
                onClick={() => onNavigate(route)}
                style={{ width: '100%', color: 'inherit', textAlign: 'left', cursor: 'pointer' }}
              >
                <span>
                  <strong>
                    {num} · <span>{title}</span>
                  </strong>
                  <small>Связано с соответствующим рабочим разделом кабинета</small>
                </span>
                <span className="dp120-badge">По плану</span>
              </button>
            ))}
          </div>
        </Card>
        <Card title="180 кредитов" sub="Типичный объём образовательной программы докторантуры." span="span12">
          <div className="dp120-callout">
            <b>180 кредитов</b> за три года: дисциплины, НИРД, практики, стажировка и итоговая аттестация.
          </div>
        </Card>
      </div>
    </>
  );
};
